"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SummaryWrapper = exports.StepWrapper = exports.Root = exports.Loader = exports.Layout = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        backgroundColor: theme.palette.grey[100],
        minHeight: '100%'
    };
});
const Layout = exports.Layout = (0, _mui.styled)('div', {
    shouldForwardProp (propName) {
        return propName !== 'godModeHeight';
    }
})((param)=>{
    let { godModeHeight, theme } = param;
    return {
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1fr)',
        alignContent: 'start',
        alignItems: 'start',
        gridTemplateAreas: "\n      'navigation'\n      'stepContent'\n      'summary'",
        columnGap: 0,
        backgroundColor: theme.palette.grey[100],
        overflow: godModeHeight > 0 ? 'scroll' : undefined,
        maxHeight: godModeHeight > 0 ? "calc(100dvh - ".concat(godModeHeight, "px)") : undefined,
        minHeight: '100%',
        padding: theme.spacing(6, 0, 40),
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(6, 6, 40)
        },
        [theme.breakpoints.up('lg')]: {
            gridTemplateColumns: 'minmax(0, 1.85fr) 1fr',
            gridTemplateRows: 'minmax(79px, auto) auto',
            gridTemplateAreas: "\n      'navigation navigation'\n      'stepContent summary'",
            columnGap: theme.spacing(6),
            boxSizing: 'border-box',
            maxWidth: 1480,
            margin: '0 auto',
            padding: theme.spacing(6, 6, 18)
        }
    };
});
const SummaryWrapper = exports.SummaryWrapper = (0, _mui.styled)('div', {
    shouldForwardProp (propName) {
        return propName !== 'isHiddenWhenSmall';
    }
})((param)=>{
    let { theme, isHiddenWhenSmall } = param;
    return {
        gridArea: 'summary',
        height: 'fit-content',
        width: '100%',
        marginTop: theme.spacing(4),
        display: isHiddenWhenSmall ? 'none' : 'block',
        [theme.breakpoints.up('lg')]: {
            position: 'sticky',
            top: 'calc(var(--top-nav-height) + 30px)',
            marginTop: 0,
            display: 'block'
        }
    };
});
const StepWrapper = exports.StepWrapper = (0, _mui.styled)('div')({
    gridArea: 'stepContent',
    height: '100%',
    width: '100%',
    margin: "0 auto",
    maxWidth: 980
});
const Loader = exports.Loader = (0, _mui.styled)('div')({
    display: 'grid',
    justifyContent: 'center',
    justifyItems: 'center',
    alignContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%'
});
